export interface AddressDefinition {
  type?: string;
}

export interface AddressRecord {
  [key: string]: {
    city: string;
    [prop: string]: any;
  };
}

export interface GetAddressTypeParams {
  def: AddressDefinition;
  data: AddressRecord;
}

export interface GetAddressTypeResult {
  isAddressType: boolean;
  addressType?: string;
  isNewAddress: boolean;
}

/**
 * Determines whether the given definition refers to an address field,
 * and if so whether it's a "new" (empty-city) address.
 */
export function getAddressType({
  def,
  data,
}: GetAddressTypeParams): GetAddressTypeResult {
  const type = def.type;
  const isAddressType =
    type === "permanentAddress" ||
    type === "temporaryAddress" ||
    type === "serviceAddress";

  let isNewAddress = false;
  if (isAddressType) {
    const record = type && data[type];
    if (record?.city === "") {
      isNewAddress = true;
    }
  }

  return {
    isAddressType,
    addressType: type,
    isNewAddress,
  };
}

export default getAddressType;
